<template>
    <v-text-field
        v-if="isEditable"
        :id="id"
        ref="text-field"
        key="enable"
        v-model="text"
        :rules="rulesData"
        :placeholder="placeholderData"
        :append-icon="appendIconData"
        :prepend-icon="prependIconData"
        :disabled="isDisabled"
        :prefix="prefix"
        :suffix="suffixData"
        :hint="hint"
        :persistent-hint="persistentHint"
        :class="className"
        :label="label"
        :type="type"
        :clearable="clearable"
        :single-line="singleLine"
        :readonly="isReadOnly"
        class="text-body-2 ma-0 pa-0 text-field"
        @focus="e => $emit('focus', e)"
        @blur="e => $emit('blur', e)"
        @update:error="e => $emit('update:error', e)"
        @click:append="$emit('click:append')"
        @keydown.13="$emit('keydown', { keyCode: 13, type: 'keydown' })"
    >
        <template v-for="(value, name) in $slots" v-slot:[name]>
            <slot :name="name" />
        </template>
    </v-text-field>
    <v-flex v-else key="disable" class="label-for-input-form pa-0">
        <label>{{ text }}</label>
    </v-flex>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'TextFieldLabel',
})
export default class TextFieldLabel extends Vue {
    @Prop({ type: [String, Number], default: '' }) value: string | number;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: [] }) rules: Array<any>;
    @Prop({ default: '' }) placeholder: string;
    @Prop({ default: '' }) appendIcon: string;
    @Prop({ default: '' }) prependIcon: string;
    @Prop({ default: '' }) suffix: string;
    @Prop({ default: '' }) hint: string;
    @Prop({ default: 'text' }) type: string;
    @Prop({ default: false }) persistentHint: boolean;
    @Prop({ default: undefined }) prefix?: string;
    @Prop({ default: undefined }) label: string;
    @Prop({ default: '' }) className?: string;
    @Prop({ default: false }) clearable: boolean;
    @Prop({ default: false }) singleLine: boolean;
    @Prop({ default: undefined }) id: string;
    @Prop({ default: false }) readonly isReadOnly: boolean;
    @Watch('value', { immediate: true })
    onValueChanged(val: string | number): void {
        this.text = val;
    }
    @Watch('text')
    onTextChanged(val: string | number): void {
        this.$emit('input', val);
    }
    @Watch('disabled')
    onDisabledChanged(val: boolean): void {
        if (!val && this.editable) {
            // IE11とEdge 対策
            // input要素にフォーカスが当たった状態でdisalbedにしたとき
            // フォーカスは外れるがblurイベントが発生しないため、表示がおかしくなるのでその対応
            (this as any).$refs['text-field'].isFocused = false;
        }
    }

    text: string | number = '';

    /**
     * getter
     */
    get isEditable(): boolean {
        return this.editable;
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get rulesData(): Array<any> {
        return this.rules;
    }
    get placeholderData(): string {
        return this.placeholder;
    }
    get appendIconData(): string {
        return this.appendIcon;
    }
    get prependIconData(): string {
        return this.prependIcon;
    }
    get suffixData(): string {
        return this.suffix;
    }

    /**
     * methods
     */
    reset(): void {
        (this as any).$refs['text-field'].reset();
    }
}
</script>

<style lang="scss" scoped>
/*IE11でエラーメッセージをアニメーション表示すると見切れるため*/
.text-field :deep(.v-messages__message) {
    transition: none;
}
</style>
